/* =========================================================================
   Tile Touch theme JS
   ========================================================================= */
(function () {
  'use strict';
  const routes = (window.theme && window.theme.routes) || {};
  const strings = (window.theme && window.theme.strings) || {};
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  const money = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let el = $('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Sticky header ---------- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  const mobileNav = $('[data-mobile-nav]');
  const overlay = $('[data-drawer-overlay]');
  function openMobileNav() { mobileNav && mobileNav.classList.add('is-open'); overlay && overlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; }
  function closeAllOverlays() {
    mobileNav && mobileNav.classList.remove('is-open');
    const cd = $('[data-cart-drawer]'); cd && cd.classList.remove('is-open'); cd && cd.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-mobile-toggle]')) { e.preventDefault(); openMobileNav(); }
    if (e.target.closest('[data-mobile-close]')) { e.preventDefault(); closeAllOverlays(); }
    if (e.target.closest('[data-drawer-overlay]')) closeAllOverlays();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllOverlays(); });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open'); cartDrawer.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-active'); document.body.style.overflow = 'hidden';
  }
  async function refreshCartUI() {
    // Re-render drawer body + header count via Section Rendering of cart snippet through cart.js route
    try {
      const res = await fetch(`${routes.cart_url}?section_id=cart-drawer-refresh`);
      // Fallback: fetch cart.js for count and re-render lines manually is complex; use dedicated section below.
    } catch (e) {}
  }
  async function updateCartCount() {
    const res = await fetch(`${routes.cart_url}.js`);
    const cart = await res.json();
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    return cart;
  }
  async function renderDrawer() {
    // Use the cart page's drawer section to re-render contents
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    if (res.ok) {
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const body = doc.querySelector('[data-cart-body]');
      const target = $('[data-cart-body]');
      if (body && target) target.innerHTML = body.innerHTML;
    }
    await updateCartCount();
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeAllOverlays(); }
  });

  async function addToCart(form, opts) {
    opts = opts || {};
    const formData = new FormData(form);
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
    try {
      const res = await fetch(routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: formData,
      });
      const data = await res.json();
      if (!res.ok) { toast(data.description || 'Could not add to cart'); }
      else {
        await renderDrawer();
        if (!opts.silent) openCart();
        toast(opts.sample ? (strings.sample_added || 'Sample added') : 'Added to cart');
      }
    } catch (err) { toast('Something went wrong'); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = original; } }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('[data-product-form]')) { e.preventDefault(); addToCart(form); }
    if (form.matches('[data-sample-form]')) { e.preventDefault(); addToCart(form, { sample: true }); }
  });

  async function changeLine(key, quantity) {
    const res = await fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await renderDrawer();
    if (document.querySelector('[data-cart-page]')) location.reload();
  }
  document.addEventListener('click', (e) => {
    const line = e.target.closest('[data-cart-line]');
    if (!line) return;
    const key = line.dataset.key;
    const input = line.querySelector('[data-qty-input]');
    if (e.target.closest('[data-cart-remove]')) { e.preventDefault(); changeLine(key, 0); }
    else if (e.target.closest('[data-qty-up]')) { changeLine(key, parseInt(input.value, 10) + 1); }
    else if (e.target.closest('[data-qty-down]')) { changeLine(key, Math.max(0, parseInt(input.value, 10) - 1)); }
  });

  /* ---------- Product page: quantity + gallery + accordions ---------- */
  $$('[data-qty-selector]').forEach((sel) => {
    const input = sel.querySelector('input');
    sel.querySelector('[data-qty-down]')?.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value, 10) - 1); });
    sel.querySelector('[data-qty-up]')?.addEventListener('click', () => { input.value = parseInt(input.value, 10) + 1; });
  });

  $$('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        gallery.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (main) main.src = thumb.dataset.full || thumb.querySelector('img').src;
      });
    });
  });

  document.addEventListener('click', (e) => {
    const trig = e.target.closest('[data-accordion-trigger]');
    if (!trig) return;
    const item = trig.closest('.accordion__item');
    const panel = item.querySelector('.accordion__panel');
    const open = item.classList.toggle('is-open');
    trig.setAttribute('aria-expanded', open);
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : 0;
  });

  /* ---------- Product variant selection ---------- */
  $$('[data-product-info]').forEach((root) => {
    const variantsScript = root.querySelector('[data-variants-json]');
    if (!variantsScript) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const addBtn = root.querySelector('[data-add-btn]');

    function selectedOptions() {
      return $$('[data-option-index]', root).map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function updateVariant() {
      const opts = selectedOptions();
      const match = variants.find((v) => opts.every((o, i) => v.options[i] === o));
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
        ? `<s>${money(match.compare_at_price)}</s> ${money(match.price)}` : money(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }
      const stockEl = root.querySelector('[data-stock-note]');
      if (stockEl && 'inv' in match) {
        const sqm = parseFloat(stockEl.dataset.sqm) || 0;
        // next arrival (custom.restock_eta via data-eta) — shown on low stock and pre-order (2026-10-20)
        const eta = String(stockEl.dataset.eta || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        const m2 = sqm > 0 ? ` (${Math.round(match.inv * sqm * 10) / 10} m²)` : '';
        let tone = 'in', text = 'In stock · ready to dispatch';
        if (match.tracked) {
          if (match.inv > 10) { text = `In stock · ${match.inv} boxes${m2} ready to ship`; }
          else if (match.inv > 0) { tone = 'low'; text = `Low stock · only ${match.inv} box${match.inv > 1 ? 'es' : ''}${m2} left${eta ? ` · more arriving approx. ${eta}` : ''}`; }
          else if (match.policy === 'continue') { tone = 'low'; text = eta ? `Pre-order · stock arrives approx. ${eta}` : 'Pre-order · dispatched as soon as stock lands'; }
          else { tone = 'out'; text = 'Out of stock'; }
        }
        stockEl.className = `stock-note stock-note--${tone}`;
        stockEl.innerHTML = `<span class="stock-note__dot"></span>${text}`;
      }
      // keep the samples-app buttons pointing at the selected variant
      document.querySelectorAll('.js-product-samples[data-sample-variant]').forEach((b) => b.setAttribute('data-sample-variant', match.id));
    }
    root.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        const group = e.target.closest('[data-option-index]');
        group.querySelectorAll('.option-value, .option-swatch').forEach((l) => l.classList.remove('is-selected'));
        e.target.closest('.option-value, .option-swatch')?.classList.add('is-selected');
        updateVariant();
      }
    });
  });

  /* ---------- Collection: native facets + sort via Section Rendering AJAX ---------- */
  const collectionRoot = $('[data-collection]');
  if (collectionRoot) {
    const sectionId = collectionRoot.dataset.sectionId;
    async function loadUrl(url, push) {
      const results = $('[data-collection-results]', collectionRoot);
      results && results.classList.add('is-loading');
      try {
        const sep = url.indexOf('?') === -1 ? '?' : '&';
        const res = await fetch(`${url}${sep}section_id=${encodeURIComponent(sectionId)}`);
        if (!res.ok) throw new Error('bad status');
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('[data-collection]');
        if (fresh) collectionRoot.innerHTML = fresh.innerHTML;
        if (window.theme.renderRangeSwatches) window.theme.renderRangeSwatches();
        if (window.theme.renderReviews) window.theme.renderReviews();
        initInfinite();
        if (push !== false) history.pushState({ tt: true }, '', url);
        const top = collectionRoot.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top, behavior: 'smooth' });
      } catch (e) { window.location.href = url; }
    }

    /* infinite scroll — append next page instead of pagination */
    let infLoading = false, io = null;
    async function appendNext() {
      const more = $('[data-infinite-more]', collectionRoot);
      if (!more || infLoading) return;
      const next = more.getAttribute('data-next-url');
      if (!next) return;
      infLoading = true; more.classList.add('is-loading');
      try {
        const sep = next.indexOf('?') === -1 ? '?' : '&';
        const res = await fetch(`${next}${sep}section_id=${encodeURIComponent(sectionId)}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const ng = doc.querySelector('[data-infinite-grid]');
        const cg = $('[data-infinite-grid]', collectionRoot);
        if (ng && cg) { while (ng.firstElementChild) cg.appendChild(ng.firstElementChild); }
        const nm = doc.querySelector('[data-infinite-more]');
        if (nm) { more.setAttribute('data-next-url', nm.getAttribute('data-next-url')); }
        else { if (io) io.disconnect(); more.remove(); }
        if (window.theme.renderRangeSwatches) window.theme.renderRangeSwatches();
        if (window.theme.renderReviews) window.theme.renderReviews();
      } catch (e) {}
      finally { infLoading = false; const m = $('[data-infinite-more]', collectionRoot); if (m) m.classList.remove('is-loading'); }
    }
    function initInfinite() {
      if (io) io.disconnect();
      const sentinel = $('[data-infinite-sentinel]', collectionRoot);
      if (!sentinel || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver((entries) => { entries.forEach((en) => { if (en.isIntersecting) appendNext(); }); }, { rootMargin: '600px' });
      io.observe(sentinel);
    }
    initInfinite();

    collectionRoot.addEventListener('click', (e) => {
      const link = e.target.closest('[data-facet-link]');
      if (link) { e.preventDefault(); loadUrl(link.getAttribute('href')); return; }
      if (e.target.closest('[data-load-more]')) { e.preventDefault(); appendNext(); }
    });
    collectionRoot.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort]')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', e.target.value);
        loadUrl(url.toString());
      }
    });
    window.addEventListener('popstate', () => loadUrl(window.location.href, false));
  }

  /* ---------- Sample: add configured sample product with a reference to the tile ---------- */
  document.addEventListener('click', async (e) => {
    const sBtn = e.target.closest('[data-sample-add]');
    if (!sBtn) return;
    e.preventDefault();
    const vid = window.theme.sampleVariantId;
    if (!vid) { toast('Sample ordering isn’t set up yet'); return; }
    const of = sBtn.dataset.sampleOf || '';
    const fd = new FormData();
    fd.append('id', vid);
    fd.append('properties[_sample]', 'true');
    if (of) fd.append('properties[Sample of]', of);
    sBtn.disabled = true;
    try {
      await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
      await renderDrawer();
      openCart();
      toast(strings.sampleAdded || 'Sample added');
    } catch (err) { toast('Something went wrong'); }
    finally { sBtn.disabled = false; }
  });

  /* ---------- Facet dropdowns: close siblings + outside click + Escape ---------- */
  document.addEventListener('click', (e) => {
    const open = $$('details.facet[open]');
    if (!open.length) return;
    const summary = e.target.closest('summary.facet__toggle');
    const panel = e.target.closest('.facet__panel');
    open.forEach((d) => {
      if ((summary && d.contains(summary)) || (panel && d.contains(panel))) return;
      d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('details.facet[open]').forEach((d) => d.removeAttribute('open'));
  });
  /* Deep-link: /collections/all-tiles#open=area opens the matching facet (colour, area, look, shape…) */
  (function openFacetFromHash() {
    const m = /(?:^|[#&])open=([a-z_]+)/i.exec(location.hash || '');
    if (!m) return;
    const key = 'filter.p.m.custom.' + m[1].toLowerCase();
    const facet = $$('details.facet').find((d) => d.querySelector('a[href*="' + key + '"]'));
    if (!facet) return;
    facet.setAttribute('open', '');
    facet.scrollIntoView({ block: 'center', behavior: 'smooth' });
  })();

  /* ---------- Predictive search ---------- */
  const searchForms = $$('[data-predictive-search]');
  searchForms.forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const results = form.querySelector('[data-search-results]');
    let t;
    input?.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { if (results) results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
          if (res.ok && results) results.innerHTML = await res.text();
        } catch (e) {}
      }, 220);
    });
  });

  /* ---------- Announcement bar rotator (mobile) ---------- */
  const annTrack = $('[data-announcement-track]');
  if (annTrack && annTrack.children.length > 1 && window.matchMedia('(max-width: 600px)').matches) {
    let i = 0; const items = Array.from(annTrack.children);
    items.forEach((it, idx) => it.style.display = idx === 0 ? '' : 'none');
    setInterval(() => { items[i].style.display = 'none'; i = (i + 1) % items.length; items[i].style.display = ''; }, 3500);
  }

  /* Expose for search toggle */
  window.theme.openCart = openCart;
})();
